<ng-container *ngIf="link$ | async as link">
  <a
    *ngIf="link.routerLink"
    [routerLink]="link.routerLink"
    [innerHtml]="link.label | highlightText: (highlightText ? [highlightText] : undefined)">
  </a>
  <span
    *ngIf="!link.routerLink"
    [innerHtml]="link.label | highlightText: (highlightText ? [highlightText] : undefined)">
  </span>
</ng-container>
